import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

//
import CLINICIMG from "../../../assets/images/about-clinic-samarkand.jpg";
import ImageOverlayCard from "../../../components/image-overlay-card/ImageOverlayCard";

export default function AboutSamarkand() {
  const { t } = useTranslation();
  const developmentParagraphs = t("aboutSamarkand").split("\n\n");

  return (
    <StyledAboutSamarkand>
      <div className="container">
        <div className="about-sam__wrap">
          <div className="about-sam__left">
            <h1>{t("aboutSamarkandTitle")}</h1>
            <div className="about-sam__content">
              {developmentParagraphs.map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}
            </div>
          </div>
          <div className="about-sam__right"></div>
        </div>
      </div>
      <ImageOverlayCard
        className="about-sam__img"
        image={CLINICIMG}
        title={t("locationSamarkand")}
        alt={t("locationSamarkand")}
      />
    </StyledAboutSamarkand>
  );
}

const StyledAboutSamarkand = styled.section`
  position: relative;
  background-color: var(--bg);

  .about-sam {
    &__wrap {
      display: grid;
      grid-template-columns: 1fr 1fr;
    }

    &__left {
      padding: 140px 70px 140px 0;

      h1 {
        margin-bottom: 24px;
        color: var(--title);
        font-size: var(--fs-section-title);
        font-weight: var(--fw-semibold);
        line-height: var(--lh-title);
      }
    }

    &__content {
      display: grid;
      gap: 18px;

      p {
        color: var(--text);
        font-size: var(--fs-body);
        font-style: normal;
        font-weight: var(--fw-regular);
        line-height: var(--lh-body);
        text-align: left;
      }
    }

    &__img {
      position: absolute;
      top: 0;
      right: 0;
      width: 50%;
      height: 100%;
    }
  }
`;
